export default "__VITE_ASSET__8a0dec3d__"